export default __webpack_public_path__ + "static/media/publishPost.42114d15.png";